<template>
  <div
    class="wl-empty-state flex flex-col items-center rounded-2xl p-4"
    :class="{
      'is-boxed border border-solid border-theme-transparent': isBoxed,
    }"
  >
    <WLIcon
      v-if="iconName"
      ref="iconRef"
      class="mb-2 text-muted"
      :name="iconName"
    />
    <p
      v-if="title"
      ref="titleRef"
      class="text-pretty text-center text-sm font-medium leading-6 text-emphasis"
      :class="{ 'text-sm': variant === EmptyStateVariant.INLINE }"
    >
      {{ title }}
    </p>
    <p
      v-if="subtitle"
      ref="subtitleRef"
      class="text-center text-sm font-normal leading-5 text-muted"
    >
      {{ subtitle }}
    </p>
    <WLButton
      v-if="buttonLabel"
      ref="buttonRef"
      :size="ButtonSize.SMALL"
      :type="ButtonType.SECONDARY"
      class="mt-6"
      @click="emit('buttonClick', $event)"
    >
      {{ buttonLabel }}
    </WLButton>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from "vue";
import { useWebHaptics } from "../../composables/use-web-haptics";
import { WLIcon } from "../icon";
import { ButtonSize, ButtonType, WLButton } from "../button";
import {
  EmptyStateVariant,
  type EmptyStateEmits,
  type EmptyStateProps,
} from "./types";
import { useTimeout } from "@vueuse/core";

const {
  isBoxed,
  hasHapticsOnMount = false,
  iconName,
  title,
  subtitle,
  buttonLabel,
  variant = EmptyStateVariant.INLINE,
} = defineProps<EmptyStateProps>();

const emit = defineEmits<EmptyStateEmits>();
const { triggerHaptic } = useWebHaptics();

onMounted(() => {
  if (!hasHapticsOnMount) return;
  useTimeout(200, {
    callback: () => {
      triggerHaptic("error");
    },
  });
});
</script>
